import { render, staticRenderFns } from "./closeBindDialog.vue?vue&type=template&id=71e1089d&scoped=true"
import script from "./closeBindDialog.vue?vue&type=script&lang=js"
export * from "./closeBindDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1089d",
  null
  
)

export default component.exports